<iframe id="inlineFrameExample"
        title="Inline Frame Example"
        width="100%"
        height="100%"
        class="frame"
        [src]="urlSafe">
</iframe>
